import "./styles/skills.css";

function Skills() {
  const technicalSkills = [
    { name: "HTML", file: "html.png" },
    { name: "CSS", file: "css.png" },
    { name: "Bootstrap", file: "bootstrap.png" },
    { name: "JavaScript", file: "javascript.png" },
    { name: "React", file: "react.png" },
    { name: "TypeScript", file: "typescript.png" },
    { name: "Angular", file: "angular.png" },
    { name: "Node.js", file: "nodejs.png" },
    { name: "npm", file: "npm.png" },
    { name: "Express.js", file: "expressjs.png" },
    { name: "Docker & Kubernetes", file: "docker-kubernetes.png" },
    { name: "Git/Gitlab", file: "gitlab.png" },
    { name: "postgreSQL", file: "postgresql.png" },
    { name: "Azure DevOps", file: "azure-devops.png" },
       { name: "AWS", file: "aws.svg" },
  ];

  const nonTechnicalSkills = [
    {
      name: "Communication & Collaboration",
      file: "communication-collaboration.png",
    },
    { name: "Strategic Partnerships", file: "strategic-partnerships.png" },
    { name: "Leadership & Teamwork", file: "leadership-teamwork.png" },
    { name: "Curiosity & Learning", file: "curiosity-learning.png" },
    { name: "Business Networking", file: "business-networking.png" },
    { name: "Branding and Marketing", file: "branding-marketing.png" },
    { name: "Project Management", file: "project-management.png" },
    { name: "Personal growth", file: "personal-growth.png" },
    { name: "Problem Solving", file: "problem-solving.png" },
    { name: "Client Success", file: "client-success.png" },
    { name: "Agile & Scrum", file: "agile-scrum.png" },
    { name: "IT Consulting", file: "it-consulting.png" },
    { name: "Creativity", file: "creativity.png" },
  ];

  return (
    <>
      <div>
        <h1 className="self skill">Skills</h1>
        <p className="about-text">
          Skills that build things. Attitude that scales. Want the full story?
          My resume’s just one click away.👇
        </p>
        <a
          href={require("../assets/Resume/Abdur Rahman resume.pdf")}
          download
          className="resume-download"
        >
          Download My Resume
        </a>
      </div>
      <div className="container-skills">
        <h2 className="self skill technical">💻Technical</h2>
        <div className="skills-list">
          {technicalSkills.map(({ name, file }, index) => (
            <div key={index} className="skill-item">
              <img
                src={`/technical/${file}`}
                className="skill-image"
                alt={`${name} logo`}
              />
              <span>{name}</span>
            </div>
          ))}
        </div>
        <h2 className="self skill technical">🎯Non technical</h2>
        <div className="skills-list">
          {nonTechnicalSkills.map(({ name, file }, index) => (
            <div key={index} className="skill-item">
              <img
                src={`/nonTechnical/${file}`}
                className="skill-image"
                alt={`${name} logo`}
              />
              <span>{name}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Skills;
